export const STATUSES = {
  UNKNOWN: 0, // No provider
  FALLBACK: 1, // No MetaMask
  LOCKED: 2, // Logged out
  AVAILABLE: 3 // Logged in
};

export const ITEM_TYPES = {
  AUCTION: 0,
  SALE: 1
};

export const SUPPORTED_BROWSERS = [
  'Chrome',
  'Firefox',
  'Brave',
  'Opera'
];

export const PROVIDERS = {
  UNKNOWN: 0,
  METAMASK: 1,
  TRUST: 2,
  TOSHI: 3,
  CIPHER: 4,
  MIST: 5,
  PARITY: 6,
  INFURA: 7,
  LOCALHOST: 8,
}

export const SUPPORTED_PROVIDERS = [
  PROVIDERS.METAMASK,
  PROVIDERS.TRUST,
  PROVIDERS.TOSHI,
  PROVIDERS.CIPHER,
  PROVIDERS.MIST,
  PROVIDERS.PARITY,
];

export const NETWORK_IDS = {
  MAINNET: 1,
  ROPSTEN: 3,
  RINKEBY: 4,
  KOVAN: 42,
  DEVELOPMENT: 5777,
};

export const NETWORK_NAMES = {
  MAINNET: 'Main',
  ROPSTEN: 'Ropsten test',
  RINKEBY: 'Rinkeby test',
  KOVAN: 'Kovan test',
  DEVELOPMENT: 'local development (e.g. Ganache)',
};

export const GTM_ENVIRONMENTS = {
  DEVELOPMENT: '&gtm_auth=o1lVPBIeSRdQqcMqhdmZpQ&gtm_preview=env-15&gtm_cookies_win=x',
  STAGING: '&gtm_auth=mFBiL7IYezOCZ4LRtMuxKA&gtm_preview=env-13&gtm_cookies_win=x',
  PRODUCTION: '&gtm_auth=vDG3LxDgK262vTnYIOE83A&gtm_preview=env-2&gtm_cookies_win=x'
}

export const ETHERSCAN_API_KEY = 'Q4WM4W3Q1PIX5RREZ458IFENEVTC48TGRD'; // TODO: StickSports API key

export const MILLISECONDS_IN_A_SECOND = 1000;

export const SECONDS_IN_A_MINUTE = 60;

export const AUCTION_REFRESH_INTEVAL = MILLISECONDS_IN_A_SECOND * 1; // 1 second

export const AUCTION_PRICE_ESTIMATE_MULTIPLIER = 1.05;

export const REGULAR_AUCTION_TIME_ADDITION = SECONDS_IN_A_MINUTE * 5; // 5 minutes



// WEBPACK FOOTER //
// ./src/config/constants.js